import React from "react";
import Image from "next/image";
import FormatDate from "@/utils/FormatDate";
function EventHero({ titel, publish_date, updatedAt, isVideo, setModal, displayThumbnail, cover }) {
    return (
        <div className="bg-[#dee9f2]">
            <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] py-8 lg:py-12">
                <div className="flex flex-col-reverse gap-6 md:flex-row md:gap-10 lg:gap-16 items-center">

                    {/* LEFT — meta + title */}
                    <div className="w-full md:w-1/2 space-y-4">

                        {/* event pill */}
                        <span className="inline-block text-[11px] font-semibold tracking-[0.12em] uppercase px-3 py-1 rounded-full bg-[#005D82]/10 text-[#005D82]">
                            Event
                        </span>

                        <h1 className="text-[22px] sm:text-[28px] lg:text-[34px] font-bold leading-tight text-gray-900">
                            {titel}
                        </h1>

                        {/* date */}
                        <div className="flex items-center gap-2 text-[13px] text-gray-500">
                            <svg
                                width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="#005D82" strokeWidth="1.8"
                            >
                                <rect x="3" y="4" width="18" height="18" rx="2" />
                                <path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round" />
                            </svg>
                            {publish_date ? FormatDate(publish_date) : FormatDate(updatedAt)}
                        </div>

                        {isVideo && (
                            <button
                                onClick={() => setModal({ open: true, url: cover?.url || displayThumbnail })}
                                className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#005D82] hover:bg-[#004a68] text-white text-[13px] font-semibold rounded transition-colors"
                            >
                                <svg width="11" height="13" viewBox="0 0 10 12" fill="white">
                                    <path d="M0 0l10 6-10 6V0z" />
                                </svg>
                                Watch Video
                            </button>
                        )}
                    </div>

                    {/* RIGHT — cover */}
{displayThumbnail && (
  <div className="w-full md:w-1/2">
    <div className="relative h-[220px] sm:h-[280px] lg:h-[360px] rounded overflow-hidden shadow-md">
      {/* Blue top border */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#005D82] z-30" />

      {/* Blurred Background */}
      <Image
        src={displayThumbnail}
        alt={titel}
        fill
        priority
        aria-hidden
        className="object-cover scale-100 blur-xl brightness-75"
      />

      {/* Optional dark overlay */}
      <div className="absolute inset-0 bg-black/20 z-10" />

      {/* Main Image */}
      <div className="absolute inset-0 z-20 p-2">
        <Image
          src={displayThumbnail}
          alt={titel}
          fill
          priority
          className="object-contain"
        />
      </div>

      {/* Video Play Button */}
      {isVideo && (
        <div
          className="absolute inset-0 z-30 flex items-center justify-center cursor-pointer group"
          onClick={() =>
            setModal({
              open: true,
              url: cover?.url || displayThumbnail,
            })
          }
        >
          <div className="w-16 h-16 rounded-full bg-black/50 border-2 border-white/70 flex items-center justify-center group-hover:bg-[#005D82]/80 transition-all">
            <svg width="20" height="24" viewBox="0 0 10 12" fill="white">
              <path d="M0 0l10 6-10 6V0z" />
            </svg>
          </div>
        </div>
      )}
    </div>
  </div>
)}
                </div>
            </div>
        </div>
    )
}

export default EventHero



